import { withDeepMemo } from "@hoc/withDeepMemo";
import { forwardRef } from "react";
import useIcon from "./hooks/useIcon";
import type { IconProps } from "./utils/propTypes";

const Icon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
    const { path, loading = false, size = Number("24"), style: styleObject = {}, className = "", onClick } = props;
    const { fill = "currentColor", ...style } = styleObject;
    const iconPathData = useIcon(path.toLowerCase());

    return (
        <svg
            ref={ref}
            className={`${className} ${loading ? "animate-spin" : ""}`.trim()}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill={fill}
            style={style}
            onClick={onClick}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d={iconPathData} fill={fill} />
        </svg>
    );
});

Icon.displayName = "Icon";

export default withDeepMemo(Icon);
